import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
@Component({
  selector: 'app-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss']
})
export class BookingFormComponent implements OnInit {
  imageUrl = 'http://localhost:8082';

  serviceId: any;
  selectedDate: any;
  service: any;
  bookingForm!: FormGroup;
  submitting = false;

  constructor(
    private router: Router,
    private apiService: ApiServiceService,
    private fb: FormBuilder,
    private location: Location
  ) {}

    goBack(): void {
  this.location.back();
}

  ngOnInit() {
    const navigation = this.router.getCurrentNavigation();
    let state = navigation?.extras.state;

    if (!state) {
      const saved = sessionStorage.getItem('bookingData');
      if (saved) {
        state = JSON.parse(saved);
      }
    }

    if (state) {
      this.serviceId = state['serviceId'];
      this.selectedDate = state['selectedDate'];
      this.createForm();
      this.getService();
      this.prefillFromProfile();
    } else {
      console.log('No booking data found');
      this.router.navigate(['/wedding-services']);
    }
  }

  createForm() {
    this.bookingForm = this.fb.group({
      customer_name: ['', Validators.required],
      customer_phone: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      customer_email: ['', [Validators.required, Validators.email]],
      function_name: ['', Validators.required],
      location: ['', Validators.required],
      additional_details: ['']
    });
  }

  prefillFromProfile() {
    try {
      const token = localStorage.getItem('sessionToken');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        // Pre-fill what we can from the JWT token
        if (payload.email) {
          this.bookingForm.patchValue({ customer_email: payload.email });
        }
        if (payload.name) {
          this.bookingForm.patchValue({ customer_name: payload.name });
        }
        if (payload.phone) {
          this.bookingForm.patchValue({ customer_phone: payload.phone });
        }
      }
    } catch (e) {
      // token decode failed — no prefill, user fills manually
    }
  }

  getService() {
    this.apiService.getServiceDetails(this.serviceId).subscribe({
      next: (res: any) => {
        this.service = res.data;
        // Auto-select location if only one option
        if (this.service?.service_locations?.length === 1) {
          this.bookingForm.patchValue({ location: this.service.service_locations[0] });
        }
      },
      error: (err) => console.error(err)
    });
  }

  get formattedDate(): string {
    if (!this.selectedDate) return '';
    const { day, month, year } = this.selectedDate;
    return `${day}/${month + 1}/${year}`;
  }

  submitBooking() {
    if (this.bookingForm.invalid) {
      this.bookingForm.markAllAsTouched();
      return;
    }

    this.submitting = true;

    const bookingPayload = {
      serviceId: this.serviceId,
      merchantId: this.service.merchantId,
      service_name: this.service.service_name,
      category: this.service.category?.name || this.service.category,
      price: this.service.price,
      selectedDate: this.selectedDate,
      booking_status: 'Pending',
      payment_status: 'Pending',
      ...this.bookingForm.value
    };

    this.apiService.createBooking(bookingPayload).subscribe({
      next: (res: any) => {
        this.submitting = false;
        sessionStorage.removeItem('bookingData');
        Swal.fire({
          icon: 'success',
          title: 'Booking Requested!',
          html: `<p style="color:#555;font-size:14px;line-height:1.6">
            Your booking request for <b>${this.service.service_name}</b> has been sent to the vendor.
            They will confirm shortly. You can track status in <b>My Bookings</b>.
          </p>`,
          confirmButtonColor: '#B01E3E',
          confirmButtonText: 'View My Bookings'
        }).then(() => {
          this.router.navigate(['/wedding-services/booking-details']);
        });
      },
      error: (err) => {
        this.submitting = false;
        Swal.fire('Error', err.error?.message || 'Failed to send booking request. Please try again.', 'error');
      }
    });
  }
}